import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable, forkJoin } from 'rxjs';

import { ReferenceDataService } from './services/reference-data.service';
import { CaptchaService } from "./services/captcha.service";

@Injectable()
export class AppResolver  {
  constructor(private referenceDataService: ReferenceDataService,
              private captchaService: CaptchaService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<Observable<any>> | Promise<Observable<any>> | Observable<any> {
    return forkJoin([
      this.captchaService.init(),
      this.referenceDataService.init(),
      this.referenceDataService.getAppInsightsKey()
    ]);
  }
}
